import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const MenuScheduleTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
`

export const MenuTableHeadCell = styled.th<{ $corner?: boolean }>`
  text-align: left;
  padding: 0.625rem;
  width: ${({ $corner }) => ($corner ? '5.625rem' : 'auto')};
  border-bottom: 1px solid ${tokens.border.hairline};
`

export const MenuTableRowLabel = styled.td`
  padding: 0.75rem;
  border-bottom: 1px solid ${tokens.border.hairline};
`

export const ModalTableScroll = styled.div`
  width: 100%;
  overflow-x: auto;
`

export const MenuCellSelectWrap = styled.div`
  width: 100%;

  p {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }
`

export const MenuCellRow = styled.div`
  width: 100%;
  padding: 1rem;
  border-radius: 0.75rem;
  border: 1px solid ${tokens.border.hairline};
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`

export const ProductionStatsRow = styled.div`
  display: flex;
  gap: 0.5rem;
  width: 100%;

  > * {
    flex: 1;
    min-width: 0;
  }
`

export const MenuGridCell = styled.td<{ $today?: boolean; $past?: boolean }>`
  padding: 0.75rem;
  font-size: 0.8125rem;
  border-bottom: 1px solid ${tokens.border.hairline};
  vertical-align: top;
  cursor: pointer;
  background: ${({ $today }) => ($today ? tokens.accent.soft : 'transparent')};
  opacity: ${({ $past }) => ($past ? 0.55 : 1)};
`

export const MenuLegendItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.3125rem;
`

export const TemplateDayBtn = styled.button<{ $active?: boolean; $filled?: boolean }>`
  width: 2.375rem;
  padding: 0.4375rem 0;
  border-radius: 0.5rem;
  border: 1px solid ${({ $active }) => ($active ? tokens.accent.base : tokens.border.hairline)};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ $active, $filled }) =>
    $active ? tokens.accent.base : $filled ? tokens.surface.raised : 'transparent'};
`
